import React, { useContext } from "react";
import SurveyFormItem, { SurveyFormItemProps } from "../SurveyFormItem/SurveyFormItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { library } from '@fortawesome/fontawesome-svg-core';


import './SurveyFormContentItem.css';
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIconOption } from "../../../IconPicker/IconPicker";
import classNames from "classnames";
import { SurveyStepContext } from "../../Util/surveyStepContext";
import { designFormItem } from "../../Util/useDesignerSelectedFormItem";

export interface SurveyFormContentItemProps extends SurveyFormItemProps {
    backgroundStyle?: null | "Card";
    icon?: FontAwesomeIconOption | null;
    contentItemSettings: Record<string,string>;
}

export default function SurveyFormContentItem(props: SurveyFormContentItemProps) {
    let surveyStepContext = useContext(SurveyStepContext)!;

    library.add(far);
    library.add(fas);

    const bg = props.contentItemSettings['iconBackground'];
    const bgColor = bg === 'Circle' || !bg ? props.contentItemSettings['iconBackgroundColor'] : 'transparent';
    const size = props.contentItemSettings['iconSize'];

    const iconClasses = {
        'circle': bg === 'Circle' || !bg,
        'medium': size === 'Medium' || !size,
        'large': size === 'Large'
    };

    const alignmentClass = props.contentItemSettings['iconAlignment'] === "Middle" ? 'survey-form-content-middle-align' : 'survey-form-content-top-align';

    function selectFormItemForDesigner() {
        if (surveyStepContext.mode === "Design" && (surveyStepContext.stepDefinition.type == "FormStep" || surveyStepContext.stepDefinition?.type == "InstructionStep") && props.index != undefined) {
            designFormItem({ stepIdentifier: surveyStepContext.stepDefinition.identifier!, index: props.index });
        }
    }

    let classes = [
        "survey-form-content", 
        alignmentClass, 
        `survey-form-content-${props.backgroundStyle?.toLowerCase() || "standard"}`
    ];

    return <div onClick={(event) => { event.stopPropagation(); selectFormItemForDesigner(); } } className={classNames(classes)}>
        {props.icon &&
            <div 
                className={ classNames(
                    "survey-form-content-icon", 
                    iconClasses
                )} 
                style={{
                    backgroundColor: bgColor,
                    color: props.contentItemSettings['iconColor']
                }}>
                {props.icon.prefix && props.icon.value &&
                    <FontAwesomeIcon icon={[ props.icon.prefix, props.icon.value]} />
                }
            </div>
        }
        <SurveyFormItem
            label={props.label}
            variant={props.variant}
            useFieldsetFormat={props.useFieldsetFormat}
            index={props.index}>
            <></>
        </SurveyFormItem>
    </div>;
}